import { ReactNode, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { IItem } from '../../slices/inventorySlice';
import { ItemInfo } from '../ItemInfo/ItemInfo';
import { ItemDetails } from '../ItemInfo/ItemDetails';

export function RewardPreview({ item, name, children }: { item?: IItem; name: string; children: ReactNode }) {
  const ref = useRef<HTMLElement>(null);
  const touch = useRef(false);
  const leaveTimer = useRef<number>();
  const [hover, setHover] = useState(false);
  const [menu, setMenu] = useState(false);
  const [details, setDetails] = useState(false);
  const rect = ref.current?.getBoundingClientRect();
  useEffect(() => {
    if (!menu) return;
    const close = (e: Event) => { if (!ref.current?.contains(e.target as Node)) setMenu(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [menu]);
  const left = rect ? Math.max(8, Math.min(rect.left - 320, window.innerWidth - 328)) : 8;
  const top = rect ? Math.max(8, Math.min(rect.top, window.innerHeight - 700)) : 8;
  const enter = () => { window.clearTimeout(leaveTimer.current); if (!touch.current && item) setHover(true); };
  const leave = () => { leaveTimer.current = window.setTimeout(() => setHover(false), 150); };
  useEffect(() => () => window.clearTimeout(leaveTimer.current), []);
  return <article ref={ref} role="button" tabIndex={item ? 0 : -1} aria-label={`ดูรายละเอียด ${name}`} aria-disabled={!item}
    onPointerDown={e => { touch.current = e.pointerType === 'touch' || e.pointerType === 'pen'; if (touch.current) setHover(false); }}
    onMouseEnter={enter}
    onMouseLeave={leave}
    onFocus={() => { if (!touch.current && item) setHover(true); }} onBlur={() => setHover(false)}
    onClick={e => { if (item && ref.current?.contains(e.target as Node)) { setHover(false); setMenu(!menu); } }}
    onKeyDown={e => { if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); if (item) { setHover(false); setMenu(!menu); } } if (e.key === 'Escape') { setMenu(false); setHover(false); } }}>
    {children}
    {menu && item && <button type="button" className="gacha-preview-action" onClick={e => { e.stopPropagation(); setMenu(false); setHover(false); setDetails(true); }}>ดูรายละเอียด</button>}
    {hover && !menu && !details && item && createPortal(<div className="gacha-item-tooltip" role="tooltip" onMouseEnter={enter} onMouseLeave={leave} style={{ left, top, maxHeight: window.innerHeight - top - 8, pointerEvents: 'auto' }}><ItemInfo item={item} inline style={{ width: '100%' }} /></div>, document.body)}
    {details && item && <div onClick={e => e.stopPropagation()}><ItemDetails item={item} onClose={() => setDetails(false)} /></div>}
  </article>;
}
